/* eslint-disable max-lines */

// 考勤规则配置
export const config = {
    name: 'attendanceRulesSettings',
    selection: false,
    index: false,
    columns: [
        {
            label: '考勤规则名称',
            prop: 'ruleName',
            fixed: 'left'
        },
        {
            label: '使用部门',
            prop: 'dept',
            fixed: 'left',
            showTooltip: false
        },
        {
            label: '考勤时间',
            prop: 'time',
            type: 'slot',
            slot: true,
            editSlot: true,
            fixed: 'left'
        }
    ],
    actions: {
        fixedWidth: 120,
        list: [
            {
                label: '编辑',
                event: 'editOpera'
            },
            {
                label: '删除',
                event: 'delete'
            }
        ]
    }
};

/* eslint-disable max-lines */

// 考勤打卡点配置
export const locationConfig = {
    name: 'attendanceLocationSettings',
    selection: false,
    index: false,
    columns: [
        {
            label: '考勤地点',
            prop: 'address',
            type: 'slot',
            slot: true,
            editSlot: true,
            fixed: 'left'
        }
    ],
    actions: {
        fixedWidth: 120,
        list: [
            {
                label: '编辑',
                event: 'editOpera'
            },
            {
                label: '删除',
                event: 'delete'
            }
        ]
    }
};
